import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Location as routerLocation } from '@angular/common';
import { FormBuilder, Validators } from '@angular/forms';
import { Location } from 'app/models/location.model';
import { MapboxService } from 'app/services/mapbox/mapbox.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocationService } from 'app/services/locations/location.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationDetailComponent } from './location-detail/location-detail.component';

declare const swal: any;

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css']
})
export class LocationsComponent implements OnInit {
  domainId: number;
  locations: Location[];
  location: Location;
  locationsDisplayedColumns: string[] = ["name", "address", "action"];
  locationsDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private activatedRouter: ActivatedRoute, 
    private locationService: LocationService,
    private dialog: MatDialog,
    private router: Router,
    private navigate: routerLocation) {
    
  }
  async ngOnInit() {
    this.location = new Location();
    this.domainId = this.activatedRouter.snapshot.params.id;
  }

  async ngAfterViewInit() {
    console.log('Cargando ubicaciones...');
    this.locations = await this.locationService.getLocations(this.domainId);
    console.log('ubicaciones', this.locations);
    this.locationsDataSource = new MatTableDataSource<any>(this.locations);
    this.locationsDataSource.paginator = this.paginator;
  }

  openLocationForm(){
    const dialogRef = this.dialog.open(LocationDetailComponent,{
      width: '700px',
      height: '700px',
      disableClose: true,
      data: {
        domainId: this.domainId,
        name: this.location.name,
        address: this.location.address,
        geolocation: this.location.geoLocation,
        locationId: this.location.id
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      // this.ngOnInit();
      this.ngOnInit();
    });
  }

  updateLocation(location: Location){
    this.location =  location;
    console.log(location);
    this.openLocationForm();
  }

  navigateBack(){
    this.navigate.back();
  }
}